const state = {
    selectedWaterPipes : [],
    selectedWaterNodes : [],
    selectedGateValves : []
}
// getters
const getters = {

}
const actions = {
    pushWaterPipe ({state,commit}, waterPipe) {
        commit('pushWaterPipe', waterPipe )
    },
    pushWaterNode ({state,commit}, waterNode) {
        commit('pushWaterNode', waterNode )
    },
    pushGateValve ({state,commit}, gateValve) {
        commit('pushGateValve', gateValve )
    },
    teardown({state,commit}){
        commit('teardown',
            {
                selectedWaterPipes : [],
                selectedWaterNodes : [],
                selectedGateValves : []
            }    
        )
    },
    removeWaterPipe({state,commit},index){
        commit('removeWaterPipe',index)
    },
    removeWaterNode({state,commit},index){
        commit('removeWaterNode',index)
    },
    removeGateValve({state,commit},index){
        commit('removeGateValve',index)  
    }      
}
const mutations = {
    pushWaterPipe (state, waterPipe) {
        const record = state.selectedWaterPipes.find(p => p['OBJECTID'] === waterPipe['OBJECTID'] )
        if(!record){
            state.selectedWaterPipes.push( waterPipe )
        }
    },
    pushWaterNode (state, waterNode) {
        const record = state.selectedWaterNodes.find(p => p['OBJECTID'] === waterNode['OBJECTID'] )
        if(!record){
            state.selectedWaterNodes.push( waterNode )
        }
    },
    pushGateValve (state, gateValve) {
        const record = state.selectedGateValves.find(p => p['OBJECTID'] === gateValve['OBJECTID'] )
        if(!record){
            state.selectedGateValves.push( gateValve )
        }
    },
    teardown(state, newState){
      Object.assign(state, newState)
    },
    removeWaterPipe(state, index){
        state.selectedWaterPipes.splice( index , 1) ;
    },
    removeWaterNode(state, index){
        state.selectedWaterNodes.splice( index , 1) ;
    },
    removeGateValve(state, index){
        state.selectedGateValves.splice( index , 1) ;
    },
    updateAttributes(state, payload){
        
        var applyTo = payload.applyTo;
        var newAttributes = payload.attributes;

        state[applyTo] = state[applyTo].map((eachItem)=>{

            return Object.assign(eachItem,newAttributes)

        });

    }   
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/waterNetworkElements.js